export const alertConstants = {
  SHOW: "ALERT_SHOW",
  CLEAR: "ALERT_CLEAR"
};
